import {combineReducers} from "redux";
import list from "./list";
import update from "./update"
import shippingMethods from "./shippingMethods/list"
import retailerList from "./retailerList"

export default combineReducers({list, update, shippingMethods, retailerList});